<template>
  <FormInput
    type="email"
    ref="field"
    :validations="emailValidations"
    autocomplete="username email"
    v-bind="_props"
    v-on="$listeners"
  />
</template>

<script>
import '@/assets/javascripts/on/helpers/validate-email'
import formFieldInterfaceMixin from '@/components/_shared/Form/form-field-interface-mixin'
import FormInput from '@/components/_shared/Form/Input/FormInput.vue'
import propsInput from '@/components/_shared/Form/Input/props-input'

export default {
  name: 'EmailFormInput',
  components: {
    FormInput,
  },
  mixins: [formFieldInterfaceMixin],

  props: { ...propsInput },

  data() {
    return {
      emailValidation: {
        validator: this.isEmailValid,
        message: this.$t('errors.invalid_email'),
      },
    }
  },

  computed: {
    emailValidations() {
      return [...(this.validations ? this.validations : []), this.emailValidation]
    },
  },

  methods: {
    isEmailValid(value) {
      return On.helpers.validateEmail(value)
    },
  },
}
</script>
